<!-- <div class="container box-1" id="why" style="margin-top:5vh;" data-aos="fade-right">
    <div class="row" style="justify-content: center;">
      
        <div class="row">
          <div class="col-4" style="text-align: center;">
            <p  id="t_s1" class="count">{{entrycount}}+</p>
            <p>ENTRIES</p>
          </div>
          <div class="col-4" style="text-align: center;" >
            <p   id="t_s2" class="count">{{mentorcount}}+</p>
            <p>MENTORS</p>
          </div>
          <div class="col-4" style="text-align: center;" >
            <p id="t_s3" class="count">{{prizescount}} lakhs</p>
            <p>PRIZE WORTH</p>
          </div>
          <div class="col-4" style="text-align: center;" >
            <p   id="t_s4" class="count">{{yearcount}}</p>
            <p>YEARS</p>
          </div>
        </div>
    </div>
  </div> -->



  <div class="count"  style="position: relative;">
    <div class="counts">
      <h2>
        15,000+
      </h2>
      <p>
        ENTRIES
      </p>
    </div>
    <div class="counts">
      <h2>
        INR 65L+
      </h2>
      <p>
        CASH PRIZE
      </p>
    </div>
    <div class="counts">
      <h2>
        200+
      </h2>
      <p>
        MENTORS
      </p>
    </div>
    <div class="counts">
      <h2>
        INR 50L+
      </h2>
      <p>
        WORTH INCENTIVES
      </p>
    </div>
    <div class="counts">
      <h2>
        25<sup>th</sup>
      </h2>
      <p>
        EDITION
      </p>
    </div>
  </div>